import React from "react";
import ViolinPlot from "./ViolinPlot";
// @ts-ignore
import ScatterPlotComponent from "./ScatterPlot";
import PlotGrid from "./PlotGrid";

export interface QualityControlPlotsProps {
  data: any[];
  className?: string;
}

const QualityControlPlots = ({
  data,
  className = "",
}: QualityControlPlotsProps): React.ReactElement => {
  if (!data || data.length === 0) {
    return <p>No QC data available.</p>;
  }

  return (
    <PlotGrid className={className}>
      <ViolinPlot data={data} metric="n_genes_by_counts" title="Genes Detected per Cell" />
      <ViolinPlot data={data} metric="total_counts" title="Total Counts per Cell" />
      <ViolinPlot data={data} metric="pct_counts_mt" title="Mitochondrial Content per Cell" />
      <ScatterPlotComponent
        data={data}
        xMetric="total_counts"
        yMetric="n_genes_by_counts"
        title="Total Counts vs Genes Detected"
      />
    </PlotGrid>
  );
};

export default QualityControlPlots;
